const TipStyle = {
    tipsBoxShow: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '18.75rem',
        position: 'relative',
    },
    tipsBoxHide: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        overflow: "hidden",
        height: 0,
        width: 0
    },
    svgBox: {
        marginTop: '2.5rem',
    },
    body: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0 2.5rem',
    },
    body1: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0 2.5rem',
        marginTop: "6.5rem",
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0.5rem 0',
        fontSize: '1.5rem',
        color: "#6d7580"
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        fontSize: '0.875rem',
        color: "#999999",
        marginTop: "0",
        wordBreak: "break-all",
    },
    buttonBoxOn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        bottom: '2.1875rem',
        fontSize: '1.125rem',
        transition: 'all 0.5s',
        cursor: "pointer",
    },
    buttonBoxOff: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        bottom: '-1rem',
        transition: 'all 0.5s',
        cursor: "pointer",
    },
    success: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15.625rem',
        height: '2.5rem',
        background: "#09bb07",
        color: '#fff',
        borderRadius: '0.25rem',
        margin:"0",
        padding:"0",
    },
    fail: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15.625rem',
        height: '2.5rem',
        background: "#ff6f72",
        color: '#fff',
        borderRadius: '0.25rem',
        margin:"0",
        padding:"0",
    },
    hint: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15.625rem',
        height: '2.5rem',
        background: "#ffbe62",
        color: '#fff',
        borderRadius: '0.25rem',
    },
    hintLeft: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '11.875rem',
        height: '2.5rem',
        background: "#ffbe62",
        color: '#fff',
        borderRadius: '0.25rem',
        margin: '0 1rem',

    },
    hintRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '11.875rem',
        height: '2.5rem',
        color: '#000',
        border: 'solid 0.08rem #dfdfdf',
        borderRadius: '0.25rem',
        margin: '0 1rem',
    },

    canvasBox: {
        position: "absolute",
        top: "0px",
        left: "0px",
        zIndex: 300,
        height: "18.75rem",
        width: "31.25rem",
    },

};
export  default TipStyle
